import { Locales } from '@griply/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPushToken } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

import { queryKey as cacheQueryKey } from './use-cached-push-notification-token-query';

export const useCreatePushTokenMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userId,
      token,
      locale,
    }: {
      userId: ID;
      token: string;
      locale: Locales;
    }) => {
      await createPushToken(userId, token, locale);
      await client.invalidateQueries({ queryKey: [cacheQueryKey] });
    },
  });
};
